import { z } from "zod";

export const verifyTotpSchema = z.object({
  code: z.string().min(1, {
    message: "You need to enter a code.",
  }),
});

export type VerifyTotpFormData = z.infer<typeof verifyTotpSchema>;
